import React from "react";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useSnackbar } from "hooks/useSnackbar";
import { SECRET_AUTO_HIDE_MS } from "utils/secrets";

interface SecretValueProps {
  loadSecret: () => Promise<string>;
}

const SecretValue = ({ loadSecret }: SecretValueProps) => {
  const { showSnackbar } = useSnackbar();
  const [value, setValue] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (value === null) return undefined;
    const timer = setTimeout(() => setValue(null), SECRET_AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, [value]);

  const toggle = async () => {
    if (value !== null) {
      setValue(null);
      return;
    }
    try {
      setLoading(true);
      setValue(await loadSecret());
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography component="span" sx={{ fontFamily: "monospace", wordBreak: "break-all" }}>
        {value ?? "********"}
      </Typography>
      <IconButton size="small" onClick={toggle} disabled={loading}>
        {loading ? (
          <CircularProgress size={16} />
        ) : value !== null ? (
          <VisibilityOff fontSize="small" />
        ) : (
          <Visibility fontSize="small" />
        )}
      </IconButton>
    </Box>
  );
};

export default SecretValue;
